import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "machinery-panel" }
const _hoisted_2 = { class: "panel-header-bar" }
const _hoisted_3 = { class: "header-tabs" }
const _hoisted_4 = {
  key: 0,
  class: "header-actions"
}
const _hoisted_5 = {
  key: 1,
  class: "header-actions"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "confirm-card" }
const _hoisted_8 = { class: "confirm-title" }
const _hoisted_9 = { class: "confirm-actions" }
const _hoisted_10 = {
  class: "confirm-card",
  style: {"min-width":"min(620px, calc(100vw - 32px))"}
}
const _hoisted_11 = { class: "confirm-title" }
const _hoisted_12 = { class: "form-grid" }
const _hoisted_13 = { class: "input-field" }
const _hoisted_14 = { class: "input-field" }
const _hoisted_15 = { class: "input-field" }
const _hoisted_16 = { class: "input-field" }
const _hoisted_17 = { class: "input-field" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "input-field" }
const _hoisted_20 = { class: "input-field" }
const _hoisted_21 = { class: "confirm-actions" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_24 = {
  key: 1,
  class: "machinery-container"
}
const _hoisted_25 = { class: "category-header" }
const _hoisted_26 = { class: "category-title" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "machinery-grid" }
const _hoisted_29 = { class: "machine-title" }
const _hoisted_30 = { class: "machine-meta" }
const _hoisted_31 = {
  key: 0,
  class: "machine-spec"
}
const _hoisted_32 = {
  key: 1,
  class: "machine-spec"
}
const _hoisted_33 = {
  key: 2,
  class: "machine-spec"
}
const _hoisted_34 = { class: "machine-actions" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 3,
  class: "rdo-loc-section"
}
const _hoisted_40 = {
  key: 0,
  class: "loc-loading"
}
const _hoisted_41 = {
  key: 1,
  class: "loc-empty",
  style: {"color":"#dc2626"}
}
const _hoisted_42 = {
  key: 2,
  class: "loc-empty"
}
const _hoisted_43 = { class: "filter-toggle-bar" }
const _hoisted_44 = {
  key: 0,
  class: "filter-active-badge"
}
const _hoisted_45 = { class: "rdo-loc-filter-bar" }
const _hoisted_46 = { class: "loc-filter-group" }
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "loc-filter-group" }
const _hoisted_49 = { class: "loc-filter-group" }
const _hoisted_50 = { class: "loc-filter-group loc-filter-zoom" }
const _hoisted_51 = { class: "loc-filter-label" }
const _hoisted_52 = { class: "loc-zoom-row" }
const _hoisted_53 = { class: "loc-zoom-value" }
const _hoisted_54 = {
  key: 0,
  class: "loc-empty"
}
const _hoisted_55 = {
  key: 1,
  class: "loc-gantt-wrap"
}
const _hoisted_56 = { class: "loc-gantt-scroll" }
const _hoisted_57 = { class: "loc-row-label" }
const _hoisted_58 = { class: "loc-row-label-text" }
const _hoisted_59 = { class: "loc-task-name" }
const _hoisted_60 = ["title"]
const _hoisted_61 = { class: "loc-legend" }
const _hoisted_62 = { class: "loc-legend-grid" }
const _hoisted_63 = { class: "loc-legend-label" }
const _hoisted_64 = {
  key: 4,
  class: "localizador-section"
}
const _hoisted_65 = { class: "filter-toggle-bar" }
const _hoisted_66 = {
  key: 0,
  class: "filter-active-badge"
}
const _hoisted_67 = { class: "loc-filter-bar" }
const _hoisted_68 = { class: "loc-filter-group loc-filter-machinery" }
const _hoisted_69 = { class: "machinery-filter-wrap" }
const _hoisted_70 = { class: "machinery-filter-tags" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 0,
  class: "loc-all-label"
}
const _hoisted_73 = { class: "machinery-filter-dropdown-wrap" }
const _hoisted_74 = {
  key: 0,
  class: "machinery-filter-dropdown"
}
const _hoisted_75 = ["onMousedown"]
const _hoisted_76 = {
  key: 0,
  class: "mf-check"
}
const _hoisted_77 = {
  key: 0,
  class: "machinery-filter-empty"
}
const _hoisted_78 = { class: "loc-filter-group" }
const _hoisted_79 = { class: "loc-filter-group" }
const _hoisted_80 = { class: "loc-filter-group" }
const _hoisted_81 = ["value"]
const _hoisted_82 = { class: "loc-filter-group loc-filter-zoom" }
const _hoisted_83 = { class: "loc-filter-label" }
const _hoisted_84 = { class: "loc-zoom-row" }
const _hoisted_85 = { class: "loc-zoom-value" }
const _hoisted_86 = {
  key: 0,
  class: "loc-loading"
}
const _hoisted_87 = {
  key: 1,
  class: "loc-empty"
}
const _hoisted_88 = {
  key: 2,
  class: "loc-gantt-wrap"
}
const _hoisted_89 = { class: "loc-gantt-scroll" }
const _hoisted_90 = { class: "loc-row-label" }
const _hoisted_91 = ["title"]
const _hoisted_92 = { class: "loc-row-label-text" }
const _hoisted_93 = { class: "loc-task-name" }
const _hoisted_94 = { class: "loc-machine-name" }
const _hoisted_95 = ["title"]
const _hoisted_96 = { class: "loc-legend" }
const _hoisted_97 = { class: "loc-legend-grid" }
const _hoisted_98 = { class: "loc-legend-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["tab-btn", { active: _ctx.activeSection === 'gerenciar' }]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeSection = 'gerenciar'))
        }, "Gerenciar Maquinário", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tab-btn", { active: _ctx.activeSection === 'localizador' }]),
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLocalizador()))
        }, "Localizador", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tab-btn", { active: _ctx.activeSection === 'rdo-localizador' }]),
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.activeSection = 'rdo-localizador'; _ctx.loadRdoLocalizador()})
        }, "Localizador de RDOs", 2)
      ]),
      (_ctx.activeSection === 'gerenciar' && !_ctx.isAnalyst)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCategoryForm = true))
            }, "+ Nova Categoria")
          ]))
        : (_ctx.activeSection === 'localizador')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportLocalizador && _ctx.exportLocalizador(...args)))
              }, "Exportar PDF")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6))
    ]),
    (_ctx.showCategoryForm)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "confirm-overlay",
          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.showCategoryForm = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.editingCategory ? 'Editar Categoria' : 'Nova Categoria'), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.categoryForm.name) = $event)),
              type: "text",
              class: "input-field-input",
              placeholder: "Nome da categoria",
              onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.saveCategory && _ctx.saveCategory(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.categoryForm.name]
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "link link-inline",
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showCategoryForm = false))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "link link-inline confirm-link",
                type: "button",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveCategory && _ctx.saveCategory(...args)))
              }, _toDisplayString(_ctx.editingCategory ? 'Atualizar' : 'Criar'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showMachineryForm)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "confirm-overlay",
          onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.showMachineryForm = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.editingMachinery ? 'Editar Máquina' : 'Nova Máquina'), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[36] || (_cache[36] = _createElementVNode("label", null, "Título", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.machineryForm.title) = $event)),
                  type: "text",
                  class: "input-field-input",
                  placeholder: "Ex: Caminhão Munck"
                }, null, 512), [
                  [_vModelText, _ctx.machineryForm.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[37] || (_cache[37] = _createElementVNode("label", null, "Capacidade (kg)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.machineryForm.capacityKg) = $event)),
                  type: "number",
                  class: "input-field-input"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.machineryForm.capacityKg,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[38] || (_cache[38] = _createElementVNode("label", null, "Capacidade de Pessoas", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.machineryForm.capacityPeople) = $event)),
                  type: "number",
                  class: "input-field-input"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.machineryForm.capacityPeople,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[39] || (_cache[39] = _createElementVNode("label", null, "Altura de Elevação (m)", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.machineryForm.liftingHeightMeters) = $event)),
                  type: "number",
                  step: "0.1",
                  class: "input-field-input"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.machineryForm.liftingHeightMeters,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[41] || (_cache[41] = _createElementVNode("label", null, "Categoria", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.machineryForm.categoryId) = $event)),
                  class: "input-field-input"
                }, [
                  _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "Selecione uma categoria", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machineryStore.state.categories, (cat) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: cat.id,
                      value: cat.id
                    }, _toDisplayString(cat.name), 9, _hoisted_18))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.machineryForm.categoryId]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[43] || (_cache[43] = _createElementVNode("label", null, "Status", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.machineryForm.status) = $event)),
                  class: "input-field-input"
                }, [...(_cache[42] || (_cache[42] = [
                  _createElementVNode("option", { value: "ativo" }, "Ativo", -1),
                  _createElementVNode("option", { value: "inativo" }, "Inativo", -1)
                ]))], 512), [
                  [_vModelSelect, _ctx.machineryForm.status]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[44] || (_cache[44] = _createElementVNode("label", null, "Notas", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.machineryForm.notes) = $event)),
                  class: "input-field-input",
                  placeholder: "Notas opcionais"
                }, null, 512), [
                  [_vModelText, _ctx.machineryForm.notes]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                class: "link link-inline",
                type: "button",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showMachineryForm = false))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "link link-inline confirm-link",
                type: "button",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.saveMachinery && _ctx.saveMachinery(...args)))
              }, _toDisplayString(_ctx.editingMachinery ? 'Atualizar' : 'Criar'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeSection === 'gerenciar')
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_ctx.machineryStore.state.categories.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[45] || (_cache[45] = [
                _createElementVNode("p", null, "Nenhuma categoria criada. Crie uma categoria para começar.", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedMachinery, (category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category.id,
                    class: "category-section"
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h3", _hoisted_26, _toDisplayString(category.name), 1),
                      (!_ctx.isAnalyst)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "icon-btn",
                            type: "button",
                            title: "Deletar categoria",
                            onClick: ($event: any) => (_ctx.deleteCategory(category.id, category.name))
                          }, "🗑", 8, _hoisted_27))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.machines, (machine) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: machine.id,
                          class: "machine-card"
                        }, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(machine.title), 1),
                          _createElementVNode("div", _hoisted_30, [
                            (machine.capacityKg)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Carga: " + _toDisplayString(machine.capacityKg) + "kg", 1))
                              : _createCommentVNode("", true),
                            (machine.capacityPeople)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Pessoas: " + _toDisplayString(machine.capacityPeople), 1))
                              : _createCommentVNode("", true),
                            (machine.liftingHeightMeters)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Altura: " + _toDisplayString(machine.liftingHeightMeters) + "m", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("button", {
                              class: "btn btn-ghost",
                              type: "button",
                              onClick: ($event: any) => (_ctx.goToLocalizador(machine.id))
                            }, "Localizador", 8, _hoisted_35),
                            (!_ctx.isAnalyst)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-ghost",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.editMachine(machine))
                                }, "Editar", 8, _hoisted_36))
                              : _createCommentVNode("", true),
                            (!_ctx.isAnalyst)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "btn btn-danger",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.deleteMachine(machine.id, machine.title))
                                }, "Deletar", 8, _hoisted_37))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      (!_ctx.isAnalyst)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "machine-card machine-add",
                            onClick: ($event: any) => (_ctx.openNewMachinery(category.id))
                          }, [...(_cache[46] || (_cache[46] = [
                            _createElementVNode("div", { style: {"font-size":"32px","margin-bottom":"8px"} }, "+", -1),
                            _createElementVNode("div", null, "Adicionar Máquina", -1)
                          ]))], 8, _hoisted_38))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeSection === 'rdo-localizador')
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          (_ctx.rdoLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Carregando relatórios…"))
            : (_ctx.rdoError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.rdoError), 1))
              : (_ctx.rdoGanttRows.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[47] || (_cache[47] = [
                    _createTextVNode(" Nenhuma ocorrência de maquinário encontrada nos relatórios.", -1),
                    _createElementVNode("br", null, null, -1),
                    _createElementVNode("small", null, "Selecione um maquinário ao criar um Relatório Diário de Obra para que ele apareça aqui.", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("button", {
                        class: "filter-toggle-btn",
                        type: "button",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showRdoFilters = !_ctx.showRdoFilters))
                      }, [
                        _cache[49] || (_cache[49] = _createElementVNode("svg", {
                          width: "15",
                          height: "15",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z" })
                        ], -1)),
                        _cache[50] || (_cache[50] = _createTextVNode(" Filtros ", -1)),
                        (_ctx.rdoActiveFilterCount > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.rdoActiveFilterCount), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass(["filter-chevron", { rotated: _ctx.showRdoFilters }]),
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [...(_cache[48] || (_cache[48] = [
                          _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                        ]))], 2))
                      ]),
                      (_ctx.rdoActiveFilterCount > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "filter-clear-btn",
                            type: "button",
                            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.clearRdoFilters && _ctx.clearRdoFilters(...args)))
                          }, "Limpar filtros"))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_Transition, { name: "filter-bar" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _cache[52] || (_cache[52] = _createElementVNode("label", { class: "loc-filter-label" }, "Maquinário", -1)),
                            _withDirectives(_createElementVNode("select", {
                              class: "loc-filter-input",
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.rdoFilterMachineId) = $event))
                            }, [
                              _cache[51] || (_cache[51] = _createElementVNode("option", { value: "" }, "Todos", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rdoMachineOptions, (m) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: m.id,
                                  value: m.id
                                }, _toDisplayString(m.title), 9, _hoisted_47))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.rdoFilterMachineId]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _cache[53] || (_cache[53] = _createElementVNode("label", { class: "loc-filter-label" }, "De", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.rdoFilterDateFrom) = $event)),
                              type: "date",
                              class: "loc-filter-input loc-date-input"
                            }, null, 512), [
                              [_vModelText, _ctx.rdoFilterDateFrom]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _cache[54] || (_cache[54] = _createElementVNode("label", { class: "loc-filter-label" }, "Até", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.rdoFilterDateTo) = $event)),
                              type: "date",
                              class: "loc-filter-input loc-date-input"
                            }, null, 512), [
                              [_vModelText, _ctx.rdoFilterDateTo]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("label", _hoisted_51, "Zoom · " + _toDisplayString(_ctx.rdoLocZoomLabel), 1),
                            _createElementVNode("div", _hoisted_52, [
                              _withDirectives(_createElementVNode("input", {
                                type: "range",
                                min: "25",
                                max: "350",
                                step: "5",
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.rdoLocZoomScale) = $event)),
                                class: "loc-zoom-slider"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.rdoLocZoomScale,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.rdoLocZoomScale) + "%", 1)
                            ])
                          ])
                        ], 512), [
                          [_vShow, _ctx.showRdoFilters]
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.rdoVisibleRows.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, " Nenhum resultado para os filtros selecionados. "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", {
                              class: "loc-gantt-grid",
                              style: _normalizeStyle({ gridTemplateColumns: `220px repeat(${_ctx.rdoVisibleDays.length}, ${_ctx.rdoLocDayW}px)` })
                            }, [
                              _cache[55] || (_cache[55] = _createElementVNode("div", { class: "loc-col-label loc-col-header" }, [
                                _createElementVNode("span", { class: "loc-col-header-text" }, "Atração / Maquinário")
                              ], -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rdoVisibleDays, (day, di) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'rdoh' + di,
                                  class: _normalizeClass(["loc-day-header", { 'loc-day-today': day === _ctx.todayStr, 'loc-day-weekend': _ctx.isWeekend(day) }])
                                }, _toDisplayString(_ctx.formatDayLabel(day)), 3))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rdoVisibleAttractions, (attr) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: 'attr-' + attr
                                }, [
                                  _createElementVNode("div", {
                                    class: "loc-project-row",
                                    style: _normalizeStyle({ gridColumn: `1 / span ${_ctx.rdoVisibleDays.length + 1}` })
                                  }, _toDisplayString(attr), 5),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rdoVisibleRows.filter(r => r.attraction === attr), (row) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: row.machineId + '|' + row.attraction
                                    }, [
                                      _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("span", {
                                          class: "loc-machine-badge",
                                          style: _normalizeStyle({ background: row.color })
                                        }, _toDisplayString(row.number), 5),
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("span", _hoisted_59, _toDisplayString(row.machineTitle), 1)
                                        ])
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rdoVisibleDays, (day, di) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: 'rdoc' + di,
                                          class: _normalizeClass(["loc-cell", { 'loc-day-today': day === _ctx.todayStr, 'loc-day-weekend': _ctx.isWeekend(day) }])
                                        }, [
                                          (row.dateSet.has(day))
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "loc-block",
                                                style: _normalizeStyle({ background: row.color }),
                                                title: row.machineTitle + ' · ' + row.attraction
                                              }, null, 12, _hoisted_60))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      }), 128))
                                    ], 64))
                                  }), 128))
                                ], 64))
                              }), 128))
                            ], 4)
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "loc-legend-title" }, "Legenda", -1)),
                            _createElementVNode("div", _hoisted_62, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rdoVisibleLegend, (entry) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: entry.id,
                                  class: "loc-legend-item"
                                }, [
                                  _createElementVNode("span", {
                                    class: "loc-legend-badge",
                                    style: _normalizeStyle({ background: entry.color })
                                  }, _toDisplayString(entry.number), 5),
                                  _createElementVNode("span", _hoisted_63, _toDisplayString(entry.title), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                  ], 64))
        ]))
      : (_ctx.activeSection === 'localizador')
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("button", {
                class: "filter-toggle-btn",
                type: "button",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showLocFilters = !_ctx.showLocFilters))
              }, [
                _cache[58] || (_cache[58] = _createElementVNode("svg", {
                  width: "15",
                  height: "15",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z" })
                ], -1)),
                _cache[59] || (_cache[59] = _createTextVNode(" Filtros ", -1)),
                (_ctx.locActiveFilterCount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.locActiveFilterCount), 1))
                  : _createCommentVNode("", true),
                (_openBlock(), _createElementBlock("svg", {
                  class: _normalizeClass(["filter-chevron", { rotated: _ctx.showLocFilters }]),
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [...(_cache[57] || (_cache[57] = [
                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                ]))], 2))
              ]),
              (_ctx.locActiveFilterCount > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "filter-clear-btn",
                    type: "button",
                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                  }, "Limpar filtros"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_Transition, { name: "filter-bar" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _cache[60] || (_cache[60] = _createElementVNode("label", { class: "loc-filter-label" }, "Maquinário", -1)),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterMachineryIds, (mid) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: mid,
                            class: "machinery-filter-tag",
                            style: _normalizeStyle({ background: _ctx.machineryColorMap[mid] })
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.machineryStore.state.machinery.find(m => m.id === mid)?.title || mid) + " ", 1),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeMachineryFilter(mid))
                            }, "✕", 8, _hoisted_71)
                          ], 4))
                        }), 128)),
                        (_ctx.filterMachineryIds.length === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_72, "Todos"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.machineryFilterSearch) = $event)),
                          type: "text",
                          class: "loc-filter-input",
                          placeholder: "Filtrar por maquinário...",
                          onFocus: _cache[29] || (_cache[29] = ($event: any) => (_ctx.machineryFilterOpen = true)),
                          onBlur: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.closeMachineryFilter && _ctx.closeMachineryFilter(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.machineryFilterSearch]
                        ]),
                        (_ctx.machineryFilterOpen)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMachineryOptions, (m) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: m.id,
                                  class: _normalizeClass(["machinery-filter-option", { selected: _ctx.filterMachineryIds.includes(m.id) }]),
                                  onMousedown: _withModifiers(($event: any) => (_ctx.toggleMachineryFilter(m.id)), ["prevent"])
                                }, [
                                  _createElementVNode("span", {
                                    class: "mf-color-dot",
                                    style: _normalizeStyle({ background: _ctx.machineryColorMap[m.id] })
                                  }, null, 4),
                                  _createTextVNode(" " + _toDisplayString(m.title) + " ", 1),
                                  (_ctx.filterMachineryIds.includes(m.id))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_76, "✓"))
                                    : _createCommentVNode("", true)
                                ], 42, _hoisted_75))
                              }), 128)),
                              (_ctx.filteredMachineryOptions.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, "Nenhum resultado"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _cache[61] || (_cache[61] = _createElementVNode("label", { class: "loc-filter-label" }, "De", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.filterDateFrom) = $event)),
                      type: "date",
                      class: "loc-filter-input loc-date-input"
                    }, null, 512), [
                      [_vModelText, _ctx.filterDateFrom]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _cache[62] || (_cache[62] = _createElementVNode("label", { class: "loc-filter-label" }, "Até", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.filterDateTo) = $event)),
                      type: "date",
                      class: "loc-filter-input loc-date-input"
                    }, null, 512), [
                      [_vModelText, _ctx.filterDateTo]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _cache[64] || (_cache[64] = _createElementVNode("label", { class: "loc-filter-label" }, "Projeto", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.filterProjectId) = $event)),
                      class: "loc-filter-input"
                    }, [
                      _cache[63] || (_cache[63] = _createElementVNode("option", { value: "" }, "Todos os projetos", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProjects, (p) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: p.id,
                          value: p.id
                        }, _toDisplayString(p.title), 9, _hoisted_81))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.filterProjectId]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("label", _hoisted_83, "Zoom · " + _toDisplayString(_ctx.locZoomLabel), 1),
                    _createElementVNode("div", _hoisted_84, [
                      _withDirectives(_createElementVNode("input", {
                        type: "range",
                        min: "25",
                        max: "350",
                        step: "5",
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.locZoomScale) = $event)),
                        class: "loc-zoom-slider"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.locZoomScale,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.locZoomScale) + "%", 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-ghost loc-filter-clear",
                    type: "button",
                    onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                  }, "Limpar")
                ], 512), [
                  [_vShow, _ctx.showLocFilters]
                ])
              ]),
              _: 1
            }),
            (_ctx.locLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, "Carregando..."))
              : (_ctx.visibleRows.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_87, " Nenhum maquinário alocado em tarefas no período selecionado. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", {
                        class: "loc-gantt-grid",
                        style: _normalizeStyle({ gridTemplateColumns: `220px repeat(${_ctx.visibleDays.length}, ${_ctx.locDayW}px)` })
                      }, [
                        _cache[65] || (_cache[65] = _createElementVNode("div", { class: "loc-col-label loc-col-header" }, [
                          _createElementVNode("span", { class: "loc-col-header-text" }, "Projeto / Tarefa")
                        ], -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleDays, (day, di) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'h' + di,
                            class: _normalizeClass(["loc-day-header", { 'loc-day-today': day === _ctx.todayStr, 'loc-day-weekend': _ctx.isWeekend(day) }])
                          }, _toDisplayString(_ctx.formatDayLabel(day)), 3))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleProjects, (proj) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: proj.id
                          }, [
                            _createElementVNode("div", {
                              class: "loc-project-row",
                              style: _normalizeStyle({ gridColumn: `1 / span ${_ctx.visibleDays.length + 1}` })
                            }, _toDisplayString(proj.title), 5),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleRows.filter(r => r.projectId === proj.id), (row) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: row.taskId + row.machineryId
                              }, [
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("span", {
                                    class: "loc-machine-badge",
                                    style: _normalizeStyle({ background: row.color }),
                                    title: row.machineryTitle
                                  }, _toDisplayString(row.number), 13, _hoisted_91),
                                  _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("span", _hoisted_93, _toDisplayString(row.taskTitle), 1),
                                    _createElementVNode("span", _hoisted_94, _toDisplayString(row.machineryTitle), 1)
                                  ])
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleDays, (day, di) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: 'c' + di,
                                    class: _normalizeClass(["loc-cell", { 'loc-day-today': day === _ctx.todayStr, 'loc-day-weekend': _ctx.isWeekend(day) }])
                                  }, [
                                    (day >= row.plannedStart && day <= row.plannedEnd)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "loc-block",
                                          style: _normalizeStyle({ background: row.color }),
                                          title: row.taskTitle + ' · ' + row.machineryTitle
                                        }, null, 12, _hoisted_95))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                }), 128))
                              ], 64))
                            }), 128))
                          ], 64))
                        }), 128))
                      ], 4)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _cache[66] || (_cache[66] = _createElementVNode("div", { class: "loc-legend-title" }, "Legenda", -1)),
                      _createElementVNode("div", _hoisted_97, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleLegend, (entry) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: entry.id,
                            class: "loc-legend-item"
                          }, [
                            _createElementVNode("span", {
                              class: "loc-legend-badge",
                              style: _normalizeStyle({ background: entry.color })
                            }, _toDisplayString(entry.number), 5),
                            _createElementVNode("span", _hoisted_98, _toDisplayString(entry.title), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
          ]))
        : _createCommentVNode("", true)
  ]))
}